import { MAX_FEC_FILE_SIZE_BYTES } from '../constants/fecImportUpload'
import { FecImportFileError } from '../enums/fecImportFileError'

const TXT_EXTENSION = '.txt'

export const getFecImportFileError = (file: File): FecImportFileError | undefined => {
  const hasTxtExtension = file.name.toLowerCase().endsWith(TXT_EXTENSION)

  if (!hasTxtExtension) {
    return FecImportFileError.InvalidFormat
  }

  if (file.size > MAX_FEC_FILE_SIZE_BYTES) {
    return FecImportFileError.FileTooLarge
  }

  return undefined
}
